<template>
  <div>dashboard</div>
</template>

<script>
export default {

};
</script>

<style>

</style>
